'use strict';

var NavigationHistoryService = function NavigationHistoryService($filter, configurationService, momentService, NavigationSectionConfig) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var MAX_ITEMS_IN_HISTORY = 10;
  var historyList = [];
  var previousMode;
  var functionToBackToMode;
  function getLabel(state) {
    return NavigationSectionConfig['app.' + state.screen] + ' - ' + rmMomentFormat(state.timestamp, 'DATE_TIME_USER_SETTINGS');
  }
  function createHistoryItem(state) {
    return {
      id: state.timestamp.valueOf(),
      label: function label() {
        return getLabel(state);
      },
      state: state
    };
  }

  /**
   * @param {string} state.screen - the screen to which we can navigate
   * @param {Date} state.timestamp - the datatime of the last interaction
   * @param state.searchCriteria - the search criteria that should be loaded when moving to the screen
   */
  function saveState(state) {
    if (!state.timestamp) {
      state.timestamp = momentService.now(momentService.FIELD.EVENT_TIME_STAMP);
    }
    if (historyList.length > 0 && state.screen === historyList[0].state.screen) {
      historyList[0] = createHistoryItem(state);
    } else {
      historyList.unshift(createHistoryItem(state));
    }
    if (historyList.length > MAX_ITEMS_IN_HISTORY) {
      historyList.pop();
    }
  }
  function getHistory() {
    return historyList;
  }
  function moveToPreviousMode() {
    functionToBackToMode(previousMode);
  }
  function setPreviousMode(mode, functionToBack) {
    previousMode = mode;
    functionToBackToMode = functionToBack;
  }
  return {
    saveState: saveState,
    getHistory: getHistory,
    moveToPreviousMode: moveToPreviousMode,
    setPreviousMode: setPreviousMode
  };
};
NavigationHistoryService.$inject = ['$filter', 'ConfigurationService', 'MomentService', 'NavigationSectionConfig'];
module.exports = NavigationHistoryService;